import html2canvas from 'html2canvas'
import jsPDF from 'jspdf'

/** Captures a rendered document element into a multi-page PDF (A4 or Letter, portrait) and downloads it. */
export async function captureToPdf(element: HTMLElement, filename: string, paper: 'A4' | 'Letter' = 'A4') {
  const canvas = await html2canvas(element, { scale: 2, useCORS: true, backgroundColor: '#ffffff', logging: false })
  const pdf = new jsPDF({ unit: 'mm', format: paper === 'A4' ? 'a4' : 'letter', orientation: 'portrait', compress: true })
  const pageWidth = pdf.internal.pageSize.getWidth()
  const pageHeight = pdf.internal.pageSize.getHeight()
  const pxPerMm = canvas.width / pageWidth
  const sliceHeightPx = Math.floor(pageHeight * pxPerMm)
  let offset = 0
  let page = 0
  while (offset < canvas.height) {
    const height = Math.min(sliceHeightPx, canvas.height - offset)
    const slice = document.createElement('canvas')
    slice.width = canvas.width
    slice.height = height
    const ctx = slice.getContext('2d')
    if (!ctx) throw new Error('Canvas is not available in this browser.')
    ctx.fillStyle = '#ffffff'
    ctx.fillRect(0, 0, slice.width, slice.height)
    ctx.drawImage(canvas, 0, offset, canvas.width, height, 0, 0, canvas.width, height)
    if (page > 0) pdf.addPage()
    pdf.addImage(slice.toDataURL('image/jpeg', 0.95), 'JPEG', 0, 0, pageWidth, height / pxPerMm)
    offset += height
    page += 1
  }
  pdf.save(filename.endsWith('.pdf') ? filename : `${filename}.pdf`)
}
